import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import Header from "layouts/profile/components/Header";
import { Card } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import EditUserProfile from "components/Modals/EditUserProfile/EditUserProfile";
import ScheduleForm from "./scheduleForm";
import DeletePreferenceModal from "components/Modals/DeletePreference/DeletePreference";

const Profile = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const [editProfileOpen, setEditProfileOpen] = useState(false);
  const [deltePreferenceOpen, setDeletePreferenceOpen] = useState(false);
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem("user") || "{}")
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={5} mb={3}>
        <Header title="Profile" />
        <Grid container spacing={2}>
          <Grid item xs={12} lg={12}>
            <Card sx={{ height: "400px", border: "none", p: '32px' }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="h4"
                  gutterBottom
                  component="div"
                  textTransform="uppercase"
                  sx={{ mb: 2 }}
                  className="profile-title"
                >
                  Personal Information
                </Typography>
                <Edit sx={{ color: "gray", cursor: "pointer" }} onClick={() => setEditProfileOpen(true)} />
              </Box>
              <Box sx={{ borderRadius: "8px" }}>
                <Typography variant="body1" component="div" sx={{ mb: 2 }}>
                  <span
                    style={{
                      fontSize: "16px",
                      color: "rgb(61 61 61 / 87%)",
                      fontWeight: "500",
                    }}
                  >
                    First Name:
                  </span>{" "}
                  <span
                    style={{
                      fontSize: "15px",
                      color: "gray",
                      fontWeight: "400",
                    }}
                  >
                    {user.firstname}
                  </span>
                </Typography>
                <Typography variant="body1" component="div" sx={{ mb: 2 }}>
                  <span
                    style={{
                      fontSize: "16px",
                      color: "rgb(61 61 61 / 87%)",
                      fontWeight: "500",
                    }}
                  >
                    Last Name:
                  </span>{" "}
                  <span
                    style={{
                      fontSize: "15px",
                      color: "gray",
                      fontWeight: "400",
                    }}
                  >
                    {user.lastname}
                  </span>
                </Typography>
                <Typography variant="body1" component="div" sx={{ mb: 2 }}>
                  <span
                    style={{
                      fontSize: "16px",
                      color: "rgb(61 61 61 / 87%)",
                      fontWeight: "500",
                    }}
                  >
                    User Name:
                  </span>{" "}
                  <span
                    style={{
                      fontSize: "15px",
                      color: "gray",
                      fontWeight: "400",
                    }}
                  >
                    {user.username}
                  </span>
                </Typography>
                <Typography variant="body1" component="div" sx={{ mb: 2 }}>
                  <span
                    style={{
                      fontSize: "16px",
                      color: "rgb(61 61 61 / 87%)",
                      fontWeight: "500",
                    }}
                  >
                    Email Address:
                  </span>{" "}
                  <span
                    style={{
                      fontSize: "15px",
                      color: "gray",
                      fontWeight: "400",
                    }}
                  >
                    {user.email}
                  </span>
                </Typography>
                <Typography variant="body1" component="div" sx={{ mb: 2 }}>
                  <span
                    style={{
                      fontSize: "16px",
                      color: "rgb(61 61 61 / 87%)",
                      fontWeight: "500",
                    }}
                  >
                    Phone:
                  </span>{" "}
                  <span
                    style={{
                      fontSize: "15px",
                      color: "gray",
                      fontWeight: "400",
                    }}
                  >
                    {user.phone}
                  </span>
                </Typography>
                <Typography variant="body1" component="div" sx={{ mb: 2 }}>
                  <span
                    style={{
                      fontSize: "16px",
                      color: "rgb(61 61 61 / 87%)",
                      fontWeight: "500",
                    }}
                  >
                    Role :
                  </span>{" "}
                  <span
                    style={{
                      fontSize: "15px",
                      color: "gray",
                      fontWeight: "400",
                    }}
                  >
                    {user.role === "user" ? "User" : user.role}
                  </span>
                </Typography>
              </Box>
            </Card>
          </Grid>

          <Grid item xs={12} mt={3}>
            <Card sx={{ height: "400px", border: "none", p: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 2,
                }}
              >
                <Typography
                  variant="h4"
                  gutterBottom
                  component="div"
                  textTransform="uppercase"
                  sx={{ mb: 2 }}
                  className="profile-title"
                >
                  Schedule Analytics Report
                </Typography>

                {user?.preferences &&
                  Object.keys(user?.preferences).length > 0 && (
                    <Delete
                      onClick={() => setDeletePreferenceOpen(true)}
                      sx={{ color: "gray", cursor: "pointer" }}
                    />
                  )}
              </Box>
              <Box sx={{ borderRadius: "8px" }}>
                <ScheduleForm user={userData} setUserData={setUserData} />
              </Box>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {editProfileOpen && (
        <EditUserProfile
          editProfileOpen={editProfileOpen}
          setEditProfileOpen={setEditProfileOpen}
        />
      )}
      {deltePreferenceOpen && (
        <DeletePreferenceModal
          setUserData={setUserData}
          deltePreferenceOpen={deltePreferenceOpen}
          setDeletePreferenceOpen={setDeletePreferenceOpen}
        />
      )}
    </DashboardLayout>
  );
};

export default Profile;
